import { LineOfBusiness } from './domain.models';

/** Illustrative thresholds of the prototype; the spec marks them "a confirmar". */
export const SYNC_STALE_DAYS: Record<LineOfBusiness, number> = {
  auto: 30,
  home: 30,
  commerce: 30,
  liability: 30,
  'personal-accident': 45,
  life: 45,
};

export const MORA_DAYS = 30;
export const PREMIUM_TOLERANCE_PCT = 3;
export const OFFER_VALID_DAYS = 15;
export const OFFER_EXPIRING_DAYS = 3;
export const CLAIM_STALE_NEWS_DAYS = 7;
export const CLAIM_DEADLINE_WARN_DAYS = 7;
export const CLAIM_REPORT_DAYS = 3;
export const CLAIM_RESPONSE_DAYS = 30;
export const CLAIM_PRESCRIPTION_DAYS = 365;
export const ENDORSEMENT_CONFIRM_MS = 5000;
export const ENDORSEMENT_REJECT_EVERY = 7;
export const CLAIM_REPORT_FAIL_EVERY = 6;
export const SELF_RENEWAL_PREMIUM_RISE_PCT = 12;
export const CLAIM_ALERT_DAYS = 5;

export const COMMISSION_TOLERANCE = 500;
export const COMMISSION_CLAIM_DUE_DAYS = 10;
export const INVITATION_VALID_DAYS = 15;
export const DOCUMENT_SHARE_VALID_DAYS = 7;
